import { render, staticRenderFns } from "./RoleManager.vue?vue&type=template&id=3e5c035d&"
import script from "./RoleManager.vue?vue&type=script&lang=js&"
export * from "./RoleManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports